/* Statisk leveringsbanner (uden jQuery): Bestil inden kl 16 * Hurtig levering */
(function(){
  function init(){
    document.querySelectorAll(".countdown[data-countdown-config]").forEach(function(root){
      if(root.dataset.cdInit) return; root.dataset.cdInit = "1";
      var cfg; try { cfg = JSON.parse(root.getAttribute("data-countdown-config")); } catch(e){ return; }
      var d = (cfg && cfg.default) || {};
      var nd = (cfg && cfg.nextDay) || {};
      var cutoffHour = (typeof nd.cutoffHour === "number") ? nd.cutoffHour : 16;
      var cutoffMin = (typeof nd.cutoffMin === "number") ? nd.cutoffMin : 0;
      var klText = "kl " + cutoffHour + (cutoffMin > 0 ? "." + (cutoffMin < 10 ? "0" : "") + cutoffMin : "");
      root.innerHTML = "";
      var wrap = document.createElement("div"); wrap.className = "countdown-default-wrapper";
      function mkImg(src){ if(!src) return null; var im = document.createElement("img"); im.className = "countdown-default--image"; im.width = 75; im.height = 75; im.loading = "lazy"; im.src = src; return im; }
      var p1 = document.createElement("p"); p1.className = "countdown-default--text";
      p1.textContent = (d.leftText || "Bestil inden") + " " + klText;
      var p2 = document.createElement("p"); p2.className = "countdown-default--text"; p2.textContent = d.rightText || "";
      var li = mkImg(d.leftImage), ri = mkImg(d.rightImage);
      if(li) wrap.appendChild(li);
      wrap.appendChild(p1);
      if(ri) wrap.appendChild(ri);
      if(d.rightText) wrap.appendChild(p2);
      root.appendChild(wrap);
    });
  }
  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", init); } else { init(); }
})();